var React = require('react');

function IcArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"none","stroke":"currentColor","strokeWidth":"2","d":"M2 11h18m-5.5-6.5L21 11l-6.5 6.5"}));
}

IcArrow.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = IcArrow;

IcArrow.default = IcArrow;
